import SetListData from "@/components/ProductDetail/v3/ProductAccordionList/SetListData"

const Features = props => {
  const {
    data: {
      isExpanded: { feature: isExpanded = false } = {},
      featuresData,
      productAccordionText = {},
      productAccordionText: { features = "" } = {},
      watersense = [],
    } = {},
  } = props

  return (
    <div
      className="pdp-features-technologies__content"
      aria-hidden={isExpanded ? "false" : "true"}
    >
      <div className="pdp-features-technologies__container">
        <SetListData
          listData={featuresData}
          showType={features}
          tabName={"features"}
          productAccordionText={productAccordionText}
        />
        {watersense.length ? (
          <div className="pdp-features-technologies__icons">
            {watersense.map((icon, i) => (
              <img key={i} src={icon} alt="watersense icon" />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default Features
